<form (ngSubmit)="saveInternship(internshipForm,internshipData.id)" #internshipForm="ngForm">
  <div class="bottom">
    <div class="header">
      <div class="title">
          <h1>{{ 'internship-dialog.add-title' | translate }}</h1>
      </div>

      <div class="close">
        <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
      </div>
    </div>

    <app-alert-message></app-alert-message>
    
    <div>
      <mat-accordion class="example-headers-align">

      <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
        <mat-panel-title><mat-icon>work</mat-icon> {{ 'internship-dialog.sections.internship-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">

        <div class="content-information">
          <label>{{ 'internship-dialog.fields.internship-title' | translate }}</label>
          <select [(ngModel)]="internshipData.id" 
                  [ngModelOptions]="{standalone: true}" 
                  (change)="onInternshipSelected($event)">
            <option value="" disabled selected>{{ 'internship-dialog.select-available' | translate }}</option>
            <option *ngFor="let internship of availableInternships" [value]="internship.id">
              {{ internship.title }}
            </option>
          </select>

        </div>

        <div class="content-information">
          <label>{{ 'internships.table.position' | translate }}</label>
          <input type="text" name="position" [(ngModel)]="internshipData.availableInternshipPosition" placeholder="{{ 'internship-dialog.placeholders.position' | translate }}" required disabled="true">
        </div>

        <div class="content-information">
          <label>{{ 'internship-dialog.fields.department' | translate }}</label>
          <input type="text" name="department" [(ngModel)]="internshipData.availableInternshipDepartment" placeholder="{{ 'internship-dialog.placeholders.department' | translate }}" required disabled="true">
        </div>

        <div class="content-information">
          <label>{{ 'profile.country' | translate }}</label>
          <input type="text" name="availableInternshipCountry" [ngModel]="selectedCountry?.name || ''" placeholder="{{ 'profile.select-country' | translate }}" disabled="true">
        </div>

        <div class="content-information">
          <label>{{ 'profile.city' | translate }}</label>
          <input type="text" name="availableInternshipCity" [ngModel]="internshipData.availableInternshipCity?.name || ''" placeholder="{{ 'profile.select-city' | translate }}" disabled="true">
        </div>

        </div>

        <div class="section-actions">
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>date_range</mat-icon> {{ 'internship-dialog.sections.period-duration' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.start-date' | translate }}</label>
            <input type="date" name="startDate" [(ngModel)]="internshipData.startDate" placeholder="{{ 'internship-dialog.placeholders.start-date' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.end-date' | translate }}</label>
            <input type="date" name="endDate" [(ngModel)]="internshipData.endDate" placeholder="{{ 'internship-dialog.placeholders.end-date' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'internships.status.label' | translate }}</label>
            <select [(ngModel)]="internshipData.status" name="status">
            <option value="" disabled selected>{{ 'internship-dialog.select-status' | translate }}</option>
            <option value="PLanned">{{ 'common.status.planned' | translate }}</option>
            <option value="Ongoind">{{ 'common.status.ongoing' | translate }}</option>
            <option value="Completed">{{ 'common.status.completed' | translate }}</option>
            </select>
          </div>
        </div>
        <div class="section-actions">
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>account_circle</mat-icon> {{ 'internship-dialog.sections.trainee-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="name" [(ngModel)]="internshipData.traineeName" placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="lastname" [(ngModel)]="internshipData.traineeLastname" placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="email" [(ngModel)]="internshipData.traineeEmail" placeholder="{{ 'internship-dialog.placeholders.email' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'profile.phone' | translate }}</label>
            <input type="text" name="phone" [(ngModel)]="internshipData.traineePhone" placeholder="{{ 'internship-dialog.placeholders.phone' | translate }}" required>
          </div>
        </div>
        <div class="section-actions">
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
          <button type="button" mat-button (click)="nextStep()">{{ 'common.next' | translate }}</button>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>supervisor_account</mat-icon> {{ 'internship-dialog.sections.supervisor-details' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="content">
           <div class="content-information">
            <label>{{ 'internship-dialog.fields.firstname' | translate }}</label>
            <input type="text" name="supervisorFirstname" [(ngModel)]="internshipData.supervisorFirstname" placeholder="{{ 'internship-dialog.placeholders.firstname' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'internship-dialog.fields.lastname' | translate }}</label>
            <input type="text" name="supervisorLastname" [(ngModel)]="internshipData.supervisorLastname" placeholder="{{ 'internship-dialog.placeholders.lastname' | translate }}" required>
          </div>

          <div class="content-information">
            <label>{{ 'profile.email' | translate }}</label>
            <input type="text" name="supervisorEmail" [(ngModel)]="internshipData.supervisorEmail" placeholder="{{ 'internship-dialog.placeholders.email' | translate }}" required>
          </div>
        </div>

        <div class="section-actions">
          <button type="button" mat-button (click)="prevStep()">{{ 'common.previous' | translate }}</button>
        </div>
      </mat-expansion-panel>

      </mat-accordion>
    </div>

  </div>

  <div class="pulsanti">
    <button class="saveButton" [disabled]="!isFormComplete()">
    <mat-icon>save</mat-icon>{{ 'common.save' | translate }}
    </button>
  </div>

</form>
